import React from 'react';
import PropTypes from 'prop-types';
import { columnSizeByList } from 'Store/lists/constants';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ListRow from 'Components/ListRow/ListRow';
import ListColumn from 'Components/ListColumn/ListColumn';

const TableHeader = ({
  sortColumn,
  columnIds,
  sortAscending,
  stickyOffset,
  handleColumnSort,
  headerStuck,
  type,
  rowSize,
}) => {
  const Triangle = () => (
    <svg
      height="10"
      width="10"
      className="ListRow__triangle"
      data-direction={sortAscending ? 'down' : 'up'}
    >
      <polygon points="5 0,10 10,0 10" className="svg-fill" />
    </svg>
  );

  const columnSizes = columnSizeByList(type);

  return (
    <ListRow
      additionalClassNames={`ListRow--header${headerStuck ? ' is-stuck' : ''}`}
      style={{ top: stickyOffset }}
      rowSize={rowSize}
      isHeader
    >
      {columnIds.map(id => (
        <ListColumn
          key={`column-${id}`}
          id={id}
          size={columnSizes[id]}
          sortHandler={handleColumnSort}
          isHeader
        >
          <ConnectedFormattedMessage id={`users_list.column_labels.${id}`} />
          {id === sortColumn ? <Triangle /> : null}
        </ListColumn>
      ))}
    </ListRow>
  );
};

TableHeader.propTypes = {
  sortColumn: PropTypes.string,
  columnIds: PropTypes.array,
  sortAscending: PropTypes.bool,
  stickyOffset: PropTypes.number,
  handleColumnSort: PropTypes.func.isRequired,
  headerStuck: PropTypes.bool,
  type: PropTypes.oneOf([
    'students_in_school',
    'students_in_class',
    'teachers_in_school',
    'schools_stats',
    'educators_stats',
  ]).isRequired,
};

TableHeader.defaultProps = {
  headerStuck: false,
  stickyOffset: 0,
  columnIds: [],
};

export default TableHeader;
